module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-02-402956af434a263cb561db908ed403c9.jpg";